<template>
    <div class="ah-product-card-bottom">
        <div class="ah-product-card-footer">
            <icon-link class="ah-product-card-link"
                       v-for="(link, i) in links"
                       :key="`link-${i}`"
                       :href="link.href"
                       :label="link.label"
                       :product="link.productId"
                       :icon="link.icon" />
        </div>
    </div>
</template>

<script>
  import IconLink from '../IconLink.vue'

  export default {
    name: 'card-footer',
    props: {
      links: Array
    },
    components: {
      IconLink,
    },
  }
</script>

<style>
    .ah-product-card-bottom {
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        justify-content: flex-end;
    }

  .ah-product-card-footer {
    padding: 0 20px 24px 20px;
    display: flex;
    flex-direction: row;
  }
  .ah-product-card-link {
    margin-right: 16px;
  }
</style>
